module.exports = __webpack_public_path__ + "img/demaecan.83798dff.png";